import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "row g-5 g-xl-8"
}
const _hoisted_2 = { class: "fs-2" }
const _hoisted_3 = { class: "col-xl-5 border border-gray-300 rounded py-3 px-4 mb-3 me-3" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { class: "col-sm-5 col-form-label fw-bolder fs-6" }, "Channel", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Nama")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Pool Account")
const _hoisted_7 = { class: "d-flex justify-content-end" }
const _hoisted_8 = { class: "indicator-label" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "Are you sure you want to submit update?", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = { class: "dialog-footer" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Confirm ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_card = _resolveComponent("el-card")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_el_card, null, {
      default: _withCtx(() => [
        (!_ctx.detail)
          ? (_openBlock(), _createBlock(_component_el_skeleton, {
              key: 0,
              animated: ""
            }))
          : (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode(_component_el_row, { class: "d-flex align-items-center mb-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("channel.detail.title")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_el_form, {
                  id: "client_edit_form",
                  model: _ctx.editChannel,
                  ref: "formRef",
                  class: "form"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createVNode(_component_el_row, {
                      gutter: 4,
                      class: "mb-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, {
                          span: 6,
                          class: "fw-bolder fs-7",
                          xs: 24
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, {
                          span: 18,
                          xs: 24
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              size: "small",
                              type: "text",
                              modelValue: _ctx.editChannel.name,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.editChannel.name = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, {
                      gutter: 4,
                      class: "mb-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, {
                          span: 6,
                          class: "fw-bolder fs-7",
                          xs: 24
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, {
                          span: 18,
                          xs: 24
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              size: "small",
                              type: "textarea",
                              rows: 2,
                              placeholder: "Please input a description of account usage",
                              modelValue: _ctx.editChannel.pool_account,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.editChannel.pool_account = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode("div", _hoisted_7, [
                      _createVNode("button", {
                        type: "button",
                        ref: "submitButton",
                        class: "btn btn-primary btn-sm",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showDialogChannel && _ctx.showDialogChannel(...args)))
                      }, [
                        _createVNode("span", _hoisted_8, _toDisplayString(_ctx.translate("saveChanges")), 1),
                        _hoisted_9
                      ], 512),
                      _createVNode(_component_el_dialog, {
                        modelValue: _ctx.dialogChanneltVisible,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogChanneltVisible = $event)),
                        title: "Confirmation",
                        width: "30%"
                      }, {
                        footer: _withCtx(() => [
                          _createVNode("span", _hoisted_12, [
                            _createVNode(_component_el_button, {
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogChanneltVisible = false))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.submitUpdate
                            }, {
                              default: _withCtx(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ]),
                        default: _withCtx(() => [
                          _hoisted_10,
                          _hoisted_11
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }, 8, ["model"])
              ])
            ]))
      ]),
      _: 1
    })
  ]))
}